import { css } from '@emotion/react'

import { Sizes } from '@thebeansgroup/sb_ui/style_helpers'
import Colours from '@thebeansgroup/ui_style_helpers/colours'
import { baby } from '@thebeansgroup/ui_style_helpers/emotion_media_queries'
import Fonts from '@thebeansgroup/ui_style_helpers/fonts'

export const email = css`
  margin-top: ${Sizes(-7)};
  margin-bottom: ${Sizes(4)};
  text-align: center;
  font-size: 16px;
  font-family: ${Fonts('gibson')};
  colour: ${Colours('liquorice', '400')};
  font-weight: bold;
`

export const image = css`
  display: block;
  width: 200px;
  height: 150px;
  margin: 0 auto;

  ${baby} {
    width: 160px;
    height: 120px;
  }
`

export const links = css`
  margin-top: ${Sizes(0)};
`

export const linkSeparator = css`
  padding: 0 ${Sizes(-7)};
`
